// extracted by css-extract-rspack-plugin
export default {"AgreementLink-icon":"sputnik__AgreementLink-icon__kKG6z","agreementLinkIcon":"sputnik__AgreementLink-icon__kKG6z"};